import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializePerformanceOptimizations } from './utils/performanceOptimizations';

// Initialize performance optimizations
initializePerformanceOptimizations();

const rootElement = document.getElementById('root') as HTMLElement;

// Production builds include crawlable route content in the initial HTML. React
// replaces that fallback once the interactive application starts.
if (rootElement.dataset.prerendered === 'true') {
  rootElement.replaceChildren();
  delete rootElement.dataset.prerendered;
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
